import { useEffect, useRef, useState } from "react";
import { getGeneralData } from "../../../../Utility/Api";
import { postGeneralDataNew } from "../../../../Utility/Api";

import "bootstrap/dist/css/bootstrap.min.css";
import { currentMonth, handlePrint, NaviGate, shop_id } from "../../../../Utility/function";
import { Paginations } from "../../../Common/Functions";
import { toast } from "react-toastify";

const GeneralLedger = () => {
  const contentRef = useRef(null);
  const [filterType, setFilterType] = useState("daily"); // daily, weekly, monthly, yearly, custom
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [selectedWeek, setSelectedWeek] = useState(getCurrentWeek());
  const [selectedMonth, setSelectedMonth] = useState(currentMonth());
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear().toString());
  const [customFromDate, setCustomFromDate] = useState("");
  const [customToDate, setCustomToDate] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [allTransactions, setAllTransactions] = useState([]);
  const [isPrinting, setIsPrinting] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);


  // Helper function to get current week range
  function getCurrentWeek() {
    const today = new Date();
    const firstDay = new Date(today.setDate(today.getDate() - today.getDay()));
    const lastDay = new Date(today.setDate(today.getDate() - today.getDay() + 6));

    return {
      start: firstDay.toISOString().split('T')[0],
      end: lastDay.toISOString().split('T')[0]
    };
  }

  // Helper function to get week range from date
  function getWeekRange(dateString) {
    const date = new Date(dateString);
    const firstDay = new Date(date.setDate(date.getDate() - date.getDay()));
    const lastDay = new Date(date.setDate(date.getDate() - date.getDay() + 6));

    return {
      start: firstDay.toISOString().split('T')[0],
      end: lastDay.toISOString().split('T')[0]
    };
  }

  useEffect(() => {
    updateDateRange();
  }, [filterType, selectedDate, selectedWeek, selectedMonth, selectedYear, customFromDate, customToDate]);

  useEffect(() => {
    if (fromDate && toDate) {
      fetchTransactionData();
    }
  }, [fromDate, toDate]);

  const updateDateRange = () => {
    let startDate = "";
    let endDate = "";

    switch (filterType) {
      case "daily":
        startDate = selectedDate;
        endDate = selectedDate;
        break;
      case "weekly":
        startDate = selectedWeek.start;
        endDate = selectedWeek.end;
        break;
      case "monthly":
        startDate = `${selectedMonth}-01`;
        const lastDay = new Date(
          new Date(startDate).getFullYear(),
          new Date(startDate).getMonth() + 1,
          0
        ).getDate();
        endDate = `${selectedMonth}-${lastDay}`;
        break;
      case "yearly":
        startDate = `${selectedYear}-01-01`;
        endDate = `${selectedYear}-12-31`;
        break;
      case "custom":
        startDate = customFromDate;
        endDate = customToDate;
        break;
      default:
        break;
    }

    setFromDate(startDate);
    setToDate(endDate);
  };

  const fetchTransactionData = async () => {
    try {
      var filter = `start_date=${fromDate}&end_date=${toDate}&shop_id=${shop_id}`;
      const res = await getGeneralData(filter);
      if (res.data && res.data.data) {
        setAllTransactions(res.data.data);
      }
    } catch (err) {
      console.log("Transaction Error", err);
    }
  };

  const handleWeekChange = (dateString) => {
    setSelectedWeek(getWeekRange(dateString));
  };

  const handlePrintAll = () => {
    setIsPrinting(true);
    // Use setTimeout to ensure state is updated before printing
    setTimeout(() => {
      handlePrint(contentRef);
      // Reset printing state after a short delay
      setTimeout(() => setIsPrinting(false), 500);
    }, 100);
  };

  const renderFilterControls = () => {
    switch (filterType) {
      case "daily":
        return (
          <div className="col-auto">
            <div className="form-floating">
              <input
                type="date"
                className="form-control"
                id="selectedDate"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
              />
              <label htmlFor="selectedDate">Select Date</label>
            </div>
          </div>
        );
      case "weekly":
        return (
          <div className="col-auto">
            <div className="form-floating">
              <input
                type="date"
                className="form-control"
                id="weekDate"
                value={selectedWeek.start}
                onChange={(e) => handleWeekChange(e.target.value)}
              />
              <label htmlFor="weekDate">Select Week</label>
            </div>
          </div>
        );
      case "monthly":
        return (
          <div className="col-auto">
            <div className="form-floating">
              <input
                type="month"
                className="form-control"
                id="selectedMonth"
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
              />
              <label htmlFor="selectedMonth">Select Month</label>
            </div>
          </div>
        );
      case "yearly":
        return (
          <div className="col-auto">
            <div className="form-floating">
              <input
                type="number"
                className="form-control"
                id="selectedYear"
                min="2000"
                max="2100"
                value={selectedYear}
                onChange={(e) => setSelectedYear(e.target.value)}
              />
              <label htmlFor="selectedYear">Select Year</label>
            </div>
          </div>
        );
      case "custom":
        return (
          <>
            <div className="col-auto">
              <div className="form-floating">
                <input
                  type="date"
                  className="form-control"
                  id="customFromDate"
                  value={customFromDate}
                  onChange={(e) => setCustomFromDate(e.target.value)}
                />
                <label htmlFor="customFromDate">From Date</label>
              </div>
            </div>
            <div className="col-auto">
              <div className="form-floating">
                <input
                  type="date"
                  className="form-control"
                  id="customToDate"
                  value={customToDate}
                  onChange={(e) => setCustomToDate(e.target.value)}
                />
                <label htmlFor="customToDate">To Date</label>
              </div>
            </div>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <div className="page-content py-1">
      <NaviGate />
      <div className="card  p-3  mx-2 overflow-y-scroll" style={{ minHeight: "90vh" }} ref={contentRef}>
        {!isPrinting && (
          <div className="row mb-4 border-bottom justify-content-between align-items-center w-100 pb-3">
            <h5 className="text-start w-auto fw-bold mb-0">
              General Ledger
            </h5>
            <div className="w-auto d-flex gap-2 mt-0 justify-content-end align-items-center">
              <div className="col-auto">
                <div className="form-floating">
                  <select
                    className="form-select"
                    id="filterType"
                    value={filterType}
                    onChange={(e) => setFilterType(e.target.value)}
                  >
                    <option value="daily">Daily</option>
                    <option value="weekly">Weekly</option>
                    <option value="monthly">Monthly</option>
                    <option value="yearly">Yearly</option>
                    <option value="custom">Custom Range</option>
                  </select>
                  <label htmlFor="filterType">Filter By</label>
                </div>
              </div>

              {renderFilterControls()}

              <button
                type="button"
                className="btn btn-dark d-none"
                onClick={handlePrintAll}
              >
                Print All
              </button>

              <button
                type="button"
                className="btn btn-primary"
                style={{ height: "58px", display: "flex", alignItems: "center" }}
                onClick={() => setShowAddModal(true)}
              >
                + Add Ledger
              </button>

            </div>
          </div>
        )}

        <div className="d-flex justify-content-between mb-3">
          <div>
            <strong>Date Range:</strong> {fromDate} to {toDate}
          </div>
        </div>

        <div className="row g-4 pt-0">
          <div className="col-md-12 mt-2">
            <TransactionTable
              transactions={allTransactions}
              dateRange={`${fromDate} to ${toDate}`}
              isPrinting={isPrinting}
            />
          </div>
        </div>

        <AddGeneralLedgerModal
          show={showAddModal}
          onClose={() => setShowAddModal(false)}
          onSuccess={() => fetchTransactionData()}
        />

      </div>
    </div>
  );
};

const TransactionTable = ({ transactions, dateRange, isPrinting }) => {
  const [transactionData, setTransactionData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const totalPages = Math.ceil(transactionData.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const paginatedData = transactionData.slice(startIndex, startIndex + rowsPerPage);

  useEffect(() => {
    const updatedTransactionData = transactions
      .filter((item) => item.status !== "-1" && item.status !== "2")
      .map((item) => {
        if (item.amount) {
          return {
            id: item.id,
            date: item.date,
            ref_id: item.ref_id,
            remarks: item.remarks,
            debit: item.is_debit == "1" ? item.amount : "0.0000",
            credit: item.is_debit == "0" ? item.amount : "0.0000",
          }
        }
        return null;
      })
      .filter(item => item !== null);

    // Sort ascending by ID so the first entry appears first
    updatedTransactionData.sort((a, b) => a.id - b.id);

    setTransactionData(updatedTransactionData);
  }, [transactions]);

  // Calculate totals
  const totalDebit = transactionData.reduce((sum, item) => sum + parseFloat(item.debit || 0), 0);
  const totalCredit = transactionData.reduce((sum, item) => sum + parseFloat(item.credit || 0), 0);

  return (
    <>
      <div className="p-0 bg-white w-full">
        <div className="w-full bg-white shadow-md rounded-lg overflow-hidden">
          <h4 className="text-xl font-bold text-center bg-dark text-white py-2 mb-0">General Ledger</h4>

          {/* Regular table view with pagination */}
          {!isPrinting && (
            <>
              <table className="w-full table border-collapse text-sm table-hover table-bordered mb-0">
                <thead>
                  <tr className="bg-green text-white">
                    <th className="py-2 px-4 text-center">Date</th>
                    <th className="py-2 px-4 text-center">Reference ID</th>
                    <th className="py-2 px-4 text-center">Remarks</th>
                    <th className="py-2 px-4 text-center">Debit (INR)</th>
                    <th className="py-2 px-4 text-center">Credit (INR)</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedData.map((item, index) => (
                    <tr key={index} className={`border-b ${index % 2 === 0 ? "bg-gray-50" : "bg-white"}`}>
                      <td className="py-2 px-4 text-center">{item?.date}</td>
                      <td className="py-2 px-4 text-center">{item?.ref_id}</td>
                      <td className="py-2 px-4 text-center">{item?.remarks}</td>
                      <td className="py-2 px-4 text-end text-green-600 font-medium">{parseFloat(item?.debit || 0).toFixed(3)}</td>
                      <td className="py-2 px-4 text-end text-green-600 font-medium">{parseFloat(item?.credit || 0).toFixed(3)}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr className="bg-light d-none">
                    <td colSpan="3" className="py-2 px-4 text-end fw-bold">Page Totals:</td>
                    <td className="py-2 px-4 text-end fw-bold">
                      {paginatedData.reduce((sum, item) => sum + parseFloat(item.debit || 0), 0).toFixed(3)}
                    </td>
                    <td className="py-2 px-4 text-end fw-bold">
                      {paginatedData.reduce((sum, item) => sum + parseFloat(item.credit || 0), 0).toFixed(3)}
                    </td>
                  </tr>
                </tfoot>
              </table>

              <Paginations
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={setCurrentPage}
              />
            </>
          )}





          {/* Print view with all data */}
          {isPrinting && (
            <div className="print-view">
              <table className="w-full table border-collapse text-sm table-bordered">
                <thead>
                  <tr className="bg-green text-white">
                    <th className="py-2 px-4 text-left">Date</th>
                    <th className="py-2 px-4 text-center">Reference ID</th>
                    <th className="py-2 px-4 text-center">Remarks</th>
                    <th className="py-2 px-4 text-center">Debit (INR)</th>
                    <th className="py-2 px-4 text-center">Credit (INR)</th>
                  </tr>
                </thead>
                <tbody>
                  {transactionData.map((item, index) => (
                    <tr key={index} className={`border-b ${index % 2 === 0 ? "bg-gray-50" : "bg-white"}`}>
                      <td className="py-2 px-4 text-center">{item?.date}</td>
                      <td className="py-2 px-4 text-center">{item?.ref_id}</td>
                      <td className="py-2 px-4 text-center">{item?.remarks}</td>
                      <td className="py-2 px-4 text-end text-green-600 font-medium">{parseFloat(item?.debit || 0).toFixed(3)}</td>
                      <td className="py-2 px-4 text-end text-green-600 font-medium">{parseFloat(item?.credit || 0).toFixed(3)}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr className="bg-light d-none">
                    <td colSpan="3" className="py-2 px-4 text-end fw-bold">Grand Totals:</td>
                    <td className="py-2 px-4 text-end fw-bold">{totalDebit.toFixed(3)}</td>
                    <td className="py-2 px-4 text-end fw-bold">{totalCredit.toFixed(3)}</td>
                  </tr>
                </tfoot>
              </table>

              <div className="mt-3 p-2 border-top">
                <div className="row">
                  <div className="col-md-6">
                    <strong>Total Transactions:</strong> {transactionData.length}
                  </div>
                  <div className="col-md-6 text-end">
                    <strong>Printed on:</strong> {new Date().toLocaleString()}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const AddGeneralLedgerModal = ({ show, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    type: "",
    ref_id: "",
    remarks: "",
    date: new Date().toISOString().split("T")[0],
    amount: "",
    paid_amount: "",
    cogs_amount: "",
    is_debit: "1",
    profitloss: "0",
  });

  useEffect(() => {
    if (show) {
      setFormData({
        type: "",
        ref_id: "",
        remarks: "",
        date: new Date().toISOString().split("T")[0],
        amount: "",
        paid_amount: "",
        cogs_amount: "",
        is_debit: "1",
        profitloss: "0",
      });
    }
  }, [show]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      let updated = { ...prev, [name]: value };

      if (name === "type") {
        // Auto debit/credit based on type
        if (value === "8" || value === "11" || value === "6" || value === "3" || value === "5") {
          updated.is_debit = "1"; // Debit
        }
        if (value === "7" || value === "12") {
          updated.is_debit = "0"; // Credit
        }
      }

      return updated;
    });
  };


  const handleSubmit = async () => {
    if (!formData.amount) {
      toast.error("Please enter an amount");
      return;
    }

    try {
      const payload = {
        ...formData,
        shop_id: shop_id,
        created_by: "1", // replace with logged-in user id
      };

      const res = await postGeneralDataNew(payload);

      if (res.data && res.data.status === "success") {
        toast.success("Entry added successfully");
        onSuccess();
        onClose();
      } else {
        toast.error(res.data.message || "Failed to add entry");
      }
    } catch (err) {
      console.error("Add ledger error", err);
      const errorMsg = err.response?.data?.message || "Failed to add ledger";
      toast.error(errorMsg);
    }
  };

  if (!show) return null;

  return (
    <div className="modal fade show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-md">
        <div className="modal-content">
          <div className="modal-header bg-success text-white">
            <h5 className="modal-title">Add General Ledger</h5>
            <button className="btn-close btn-close-white" onClick={onClose} />
          </div>

          <div className="modal-body">
            <div className="form-group mb-2">
              <label>Ledger Type</label>
              <select
                className="form-select"
                name="type"
                value={formData.type}
                onChange={handleChange}
                required
              >
                <option value="">Select Type</option>
                <option value="6">Expense</option>
                <option value="3">Stock Purchase</option>
                <option value="5">Sales</option>
              </select>
            </div>


            <div className="form-group mb-2">
              <label>Reference ID</label>
              <input
                type="text"
                className="form-control"
                name="ref_id"
                value={formData.ref_id}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mb-2">
              <label>Date</label>
              <input
                type="date"
                className="form-control"
                name="date"
                value={formData.date}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mb-2">
              <label>Amount</label>
              <input
                type="number"
                className="form-control"
                name="amount"
                value={formData.amount}
                onChange={handleChange}
              />
            </div>

            {(formData.type === "3" || formData.type === "5") && (
              <div className="form-group mb-2">
                <label>Paid Amount</label>
                <input
                  type="number"
                  className="form-control"
                  name="paid_amount"
                  value={formData.paid_amount}
                  onChange={handleChange}
                />
              </div>
            )}

            {formData.type === "5" && (
              <div className="form-group mb-2">
                <label>COGS Amount</label>
                <input
                  type="number"
                  className="form-control"
                  name="cogs_amount"
                  value={formData.cogs_amount}
                  onChange={handleChange}
                />
              </div>
            )}

            <div className="form-group mb-2">
              <label>Debit / Credit</label>
              <select
                className="form-select"
                name="is_debit"
                value={formData.is_debit}
                onChange={handleChange}
                disabled={formData.type === "6"}
              >
                <option value="1">Debit</option>
                {formData.type !== "6" && <option value="0">Credit</option>}
              </select>
            </div>

            <div className="form-group mb-2">
              <label>Remarks</label>
              <input
                type="text"
                className="form-control"
                name="remarks"
                value={formData.remarks}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button className="btn btn-success" onClick={handleSubmit}>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};


export default GeneralLedger;